import Parse from 'html-react-parser';

function BMP20135(props) {
    let svgCode =
    `<svg width="700" height="27" viewBox="0 0 700 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    ${props.fontFace}
    </style>
        <rect width="694" height="24" fill="${props.paramFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="bold" letter-spacing="0em"><tspan x="27" y="17.9688">SIZE</tspan></text>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="bold" letter-spacing="0em"><tspan x="139" y="17.9688">DECAY</tspan></text>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="bold" letter-spacing="0em"><tspan x="248" y="17.9688">LOW CUT</tspan></text>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="bold" letter-spacing="0em"><tspan x="366" y="17.9688">HIGH CUT</tspan></text>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="bold" letter-spacing="0em"><tspan x="504" y="17.9688">SPIN</tspan></text>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="16" font-weight="bold" letter-spacing="0em"><tspan x="597" y="17.9688">SPIN DEPTH</tspan></text>
    </svg>`

    props.svgReturn(5, svgCode, "bmp00135", 700, 27);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20135;